import basketOffIcon from "../../assets/icons/sports/basketball-disabled.png";
import basketIcon from "../../assets/icons/sports/basketball.png";
import handballOffIcon from "../../assets/icons/sports/handball-disabled.png";
import handballIcon from "../../assets/icons/sports/handball.png";
import soccerOffIcon from "../../assets/icons/sports/soccer-disabled.png";
import soccerIcon from "../../assets/icons/sports/soccer.png";
import tennisOffIcon from "../../assets/icons/sports/tennis-disabled.png";
import tennisIcon from "../../assets/icons/sports/tennis.png";
import volleyOffIcon from "../../assets/icons/sports/volleyball-disabled.png";
import volleyIcon from "../../assets/icons/sports/volleyball.png";

import BoletimSection from "../BoletimSection/BoletimSection";
import CardImageGrid from "../CardImageGrid/CardImageGrid";

function Esportes({ esportes }) {
	const SPORTS = [
		{
			desc: "Basquete",
			image: esportes.includes("basquete") ? basketIcon : basketOffIcon,
			disabled: esportes.includes("basquete") ? false : true,
            show: esportes.includes("basquete") ? true : false,
		},
		{
			desc: "Futsal",
			image: esportes.includes("futsal") ? soccerIcon : soccerOffIcon,
			disabled: esportes.includes("futsal") ? false : true,
            show: true,
		},
		{
			desc: "Handebol",
			image: esportes.includes("handebol")
				? handballIcon
				: handballOffIcon,
			disabled: esportes.includes("handebol") ? false : true,
            show: esportes.includes("handebol") ? true : false,
		},
		{
			desc: "Tênis",
			image: esportes.includes("tenis") ? tennisIcon : tennisOffIcon,
			disabled: esportes.includes("tenis") ? false : true,
            show: true,
		},
		{
			desc: "Vôlei",
			image: esportes.includes("volei") ? volleyIcon : volleyOffIcon,
			disabled: esportes.includes("volei") ? false : true,
            show: true,
		},
	];
	return (
		<BoletimSection
			title="Esportes"
			icon="ball"
		>
			<CardImageGrid
				type={"sports"}
				items={SPORTS}
				imageStyles={{ width: "80%", padding: "48px" }}
			/>
		</BoletimSection>
	);
}

export default Esportes;
